import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import moment from 'moment'
import { RESPONSE_MESSAGE } from '../utils/constants'
import axios from 'axios'

const FETCH_BRAND_ACTIVITY_REQUEST = 'Brand/FETCH_BRAND_ACTIVITY_REQUEST'
const FETCH_BRAND_ACTIVITY_SUCCESS = 'Brand/FETCH_BRAND_ACTIVITY_SUCCESS'
const FETCH_BRAND_ACTIVITY_FAILURE = 'Brand/FETCH_BRAND_ACTIVITY_FAILURE'

const FETCH_BRAND_ACTIVITY_BY_ID_REQUEST =
  'Brand/FETCH_BRAND_ACTIVITY_BY_ID_REQUEST'
const FETCH_BRAND_ACTIVITY_BY_ID_SUCCESS =
  'Brand/FETCH_BRAND_ACTIVITY_BY_ID_SUCCESS'
const FETCH_BRAND_ACTIVITY_BY_ID_FAILURE =
  'Brand/FETCH_BRAND_ACTIVITY_BY_ID_FAILURE'

const CREATE_BRAND_ACTIVITY_REQUEST = 'Brand/CREATE_BRAND_ACTIVITY_REQUEST'
const CREATE_BRAND_ACTIVITY_SUCCESS = 'Brand/CREATE_BRAND_ACTIVITY_SUCCESS'
const CREATE_BRAND_ACTIVITY_FAILURE = 'Brand/CREATE_BRAND_ACTIVITY_FAILURE'

const UPDATE_BRAND_ACTIVITY_REQUEST = 'Brand/UPDATE_BRAND_ACTIVITY_REQUEST'
const UPDATE_BRAND_ACTIVITY_SUCCESS = 'Brand/UPDATE_BRAND_ACTIVITY_SUCCESS'
const UPDATE_BRAND_ACTIVITY_FAILURE = 'Brand/UPDATE_BRAND_ACTIVITY_FAILURE'

const UPDATE_BRAND_ACTIVITY_STATUS_REQUEST =
  'Brand/UPDATE_BRAND_ACTIVITY_STATUS_REQUEST'
const UPDATE_BRAND_ACTIVITY_STATUS_SUCCESS =
  'Brand/UPDATE_BRAND_ACTIVITY_STATUS_SUCCESS'
const UPDATE_BRAND_ACTIVITY_STATUS_FAILURE =
  'Brand/UPDATE_BRAND_ACTIVITY_STATUS_FAILURE'

const DELETE_BRAND_ACTIVITY_REQUEST = 'Brand/DELETE_BRAND_ACTIVITY_REQUEST'
const DELETE_BRAND_ACTIVITY_SUCCESS = 'Brand/DELETE_BRAND_ACTIVITY_SUCCESS'
const DELETE_BRAND_ACTIVITY_FAILURE = 'Brand/DELETE_BRAND_ACTIVITY_FAILURE'

const FETCH_COVER_LIST_REQUEST = 'FETCH_COVER_LIST_REQUEST'
const FETCH_COVER_LIST_SUCCESS = 'FETCH_COVER_LIST_SUCCESS'
const FETCH_COVER_LIST_FAILURE = 'FETCH_COVER_LIST_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  brandActivityList: [],
  brandActivityObj: {},
  id: null, // ✅ เก็บ `id` ของ BrandActivity
  images: [],
  loading: false,
  error: null
}

// Default Reducer
const brandActivity = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandActivityList: action.payload
      }
    case FETCH_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRAND_ACTIVITY_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_ACTIVITY_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandActivityObj: action.payload
      }
    case FETCH_BRAND_ACTIVITY_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRAND_ACTIVITY_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRAND_ACTIVITY_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRAND_ACTIVITY_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default brandActivity

// Action Creators
export const fetchBrandActivityList = (brandId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_ACTIVITY_REQUEST
      })

      const { data } = await API.post(
        EndPoints.BRAND_ACTIVITY + '/activity-list',
        { brandId: brandId, enable: false }
      )
      const addRangeDateResp = data.brandActivityList.map((brandActivity) => {
        return {
          ...brandActivity,
          rangeActiveDate: `${moment(brandActivity.effectiveDate).format(
            'D MMMM YYYY'
          )}-${moment(brandActivity.expirationDate).format('D MMMM YYYY')}`,
          status: brandActivity.enabled
            ? moment(brandActivity.expirationDate).isBefore(moment(), 'day')
              ? 'Expire'
              : 'Active'
            : 'Inactive'
        }
      })

      dispatch({
        type: FETCH_BRAND_ACTIVITY_SUCCESS,
        payload: addRangeDateResp
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}

export const fetchBrandActivityCoverList = (brandActivityId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COVER_LIST_REQUEST
      })

      const token = localStorage.getItem('user-token')

      const { data } = await API.get(
        `${EndPoints.BRAND_ACTIVITY}/coverList/${brandActivityId}`,
        {
          headers: {
            Authorization: token
          }
        }
      )

      const formattedCoverList = data.images.map((cover) => ({
        id: cover.id,
        uid: cover.uid,
        name: cover.name,
        filename: cover.filename,
        status: cover.status,
        url: cover.url,
        createdAt: moment(cover.createdAt).format('D/MMM/YYYY HH:mm'),
        updatedAt: moment(cover.updatedAt).format('D/MMM/YYYY HH:mm')
      }))

      dispatch({
        type: FETCH_COVER_LIST_SUCCESS,
        payload: {
          id: data.id,
          images: formattedCoverList
        }
      })
      return data.images
    } catch (err) {
      console.error('❌ Error fetching cover list:', err)

      dispatch({
        type: FETCH_COVER_LIST_FAILURE
      })
    }
  }
}

export const createBrandActivity = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BRAND_ACTIVITY_REQUEST
      })

      const response = await API.post(EndPoints.BRAND_ACTIVITY, data)

      dispatch({
        type: CREATE_BRAND_ACTIVITY_SUCCESS
      })

      message.success(RESPONSE_MESSAGE.SUCCESS)

      return response.data
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BRAND_ACTIVITY_FAILURE
      })

      throw err
    }
  }
}

export const updateBrandActivity = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_REQUEST
      })
      await API.put(EndPoints.BRAND_ACTIVITY, data)
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}

export const updateBrandActivityStatus = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_STATUS_REQUEST
      })
      const brandActivityId = data.brandActivityId
      const enable = data.enable
      await API.put(EndPoints.BRAND_ACTIVITY + '/status', null, {
        params: {
          brandActivityId: brandActivityId,
          enable: enable
        }
      })
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_STATUS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_STATUS_FAILURE
      })
    }
  }
}

export const deleteBrandActivity = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRAND_ACTIVITY_REQUEST
      })
      await API.delete(EndPoints.BRAND_ACTIVITY + `/${id}`)
      dispatch({
        type: DELETE_BRAND_ACTIVITY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}
